//MARK: Done
export const DATA = {
  DATA: {
    RAWS: "data/raws",
    USAGE: "data/usage",
    MIXED: "data/mixed",
    AVERAGE: {
      INDEX: "data/average",
      TIME_SERIES: "data/average/timeseries",
    },
  },
};
